









import { Vue, Component, Prop } from 'vue-property-decorator';
import Checkbox from '../common/inputs/Checkbox.vue';

@Component({
  components: {
    Checkbox
  }
})
export default class SearchOption extends Vue {
  @Prop(Boolean) value!: boolean;
}
